export default {"src":"/_next/static/media/moveToUK.ed2e5db2.svg","height":103,"width":137};